import React, { useContext } from "react"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing"

import { SITE_NAME } from "../../seo/build-seo"
import Seo from "./index"

// Páginas internas ficam fora dos buscadores. Aberta como modal, a página não
// troca as tags da que está por baixo.
export default function withNoindex(Component, title) {
  return function NoindexPage(props) {
    const { modal } = useContext(ModalRoutingContext) || {}

    return (
      <>
        {!modal && <Seo metaTitle={`${title} | ${SITE_NAME}`} noindex />}
        <Component {...props} />
      </>
    )
  }
}
